<template>
  <div class="header">
    <h1
      class="title"
      v-if="workspace && workspace.channel"
      >
      <Button
        ghost
        type="text"
        icon="md-menu"
        @click="showSidebar"
        />
      {{ workspace.channel.name }} / {{ workspace.name }}
    </h1>
    <div class="menu">
      <Dropdown placement="bottom-end">
        <a href="javascript:void(0)">
          <Avatar>U</Avatar>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem>
            <a href="#" @click="resetPasswordModal.show = true">
              パスワード変更
            </a>
          </DropdownItem>
          <DropdownItem v-if="isAdministrable">
            <a href="/console" target="_blank">
              管理画面
            </a>
          </DropdownItem>
          <DropdownItem>
            <a href="/auth/logout?to=/login">
              ログアウト
            </a>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="attention">
      <Poptip trigger="hover" content="content" placement="bottom-end" width="450">
        <Button
          ghost
          size="small"
          class="button"
          >
          <Icon type="md-warning" />
          本日の注意事項
        </Button>
        <div slot="content">
          <div class="content">
            <List
              item-layout="vertical"
              v-if="workspace && workspace.channel"
              >
              <ListItem
                v-for="msg in workspace.channel.messages"
                :key="msg.id"
                >
                <h4>
                  <a v-if="'ref' in msg.meta" :to="msg.meta.ref" target="_blank">
                    {{ msg.text }}
                  </a>
                  <template v-else>
                    {{ msg.text}}
                  </template>
                </h4>
                <p>{{ msg.meta.note }}</p>
                <template slot="action">
                  <li>
                    {{ msg.created_at | formatDate('MM/DD HH:mm') }}
                  </li>
                  <li v-if="isWritable(workspace.channel_id)">
                    <Button type="text" size="small" @click="setChannelMessageModalTarget(msg)">編集</Button>
                  </li>
                  <li v-if="isWritable(workspace.channel_id)">
                    <Button
                      type="text"
                      @click="deleteChannelMessage({channelId: $route.params.channelId, channelMessageId: msg.id})">
                      削除
                    </Button>
                  </li>
                </template>
              </ListItem>
            </List>
            <Button
              long
              v-if="workspace && isWritable(workspace.channel_id)"
              style="margin-top: 2em;"
              @click="setChannelMessageModalTarget({text: null, meta: {}})"
              >
              メッセージを追加</Button>
          </div>
        </div>
      </Poptip>
    </div>
    <div class="marquee">
      <marquee
        v-if="workspace && workspace.channel"
        style="font-size: 15px; vertical-align: middle; font-weight: bold; color: #fff200;">
        <span
          v-for="msg in workspace.channel.messages"
          style="padding-right: 2.0em;"
          >
          ({{ msg.created_at | formatDate('M/DD') }})
          {{ msg.text }}
        </span>
      </marquee>
    </div>
    <Modal
      :closable="false"
      footer-hide
      v-model="resetPasswordModal.show"
    >
      <Form :model="resetPasswordModal.data">
        <FormItem v-if="!!currentUserId">
          <p>
            <span style="font-weight: bold">ユーザ名: </span>
            <span>{{ currentUserId }}</span>
          </p>
        </FormItem>
        <FormItem label="いまのパスワード">
          <Input type="password" v-model="resetPasswordModal.data.oldPassword"></Input>
        </FormItem>
        <FormItem label="新しいパスワード">
          <Input type="password" v-model="resetPasswordModal.data.newPassword"></Input>
        </FormItem>
        <FormItem label="新しいパスワード（確認）">
          <Input type="password" v-model="resetPasswordModal.data.newPasswordConform"></Input>
        </FormItem>
        <Alert
          type="error"
          style="margin: 1em 0;"
          v-if="resetPasswordModal.message">
          {{ resetPasswordModal.message }}
        </Alert>
        <Alert
          type="error"
          style="margin: 1em 0;"
          v-if="!!resetPasswordModal.data.newPassword && resetPasswordModal.data.newPassword.length < 8">
          パスワードは8文字以上入力してください。
        </Alert>
      </Form>
      <div>
        <Button
          type="primary"
          @click="resetPassword"
          :disabled="!resetPasswordModal.data.newPassword || resetPasswordModal.data.newPassword != resetPasswordModal.data.newPasswordConform || resetPasswordModal.data.newPassword.length < 8"
          style="float: right"
          >更新</Button>
        <Button @click="resetPasswordModal.show = false">キャンセル</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { formatDate } from '../../utils'

export default {
  data() {
    return {
      postNotificationModal: {
        show: false,
        text: null,
        note: null
      },
      resetPasswordModal: {
        show: false,
        message: null,
        data: {
          oldPassword: null,
          newPassword: null,
          newPasswordConfirm: null
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getWorkspace',
      'currentUserId',
      'isWritable',
      'isAdministrable',
    ]),
    workspace() {
      return this.getWorkspace(this.$route.params)
    }
  },
  filters: {
    formatDate,
  },
  methods: {
    ...mapActions({
      setChannelMessageModalTarget: 'dashboard/setChannelMessageModalTarget',
      deleteChannelMessage: 'deleteChannelMessage',
    }),
    showSidebar() {
      this.$emit('show-sidebar')
    },
    async resetPassword() {
      const msg = await this.$store.dispatch('updateMePassword', {
        userId: this.currentUserId,
        oldPassword: this.resetPasswordModal.data.oldPassword,
        newPassword: this.resetPasswordModal.data.newPassword,
      })
      if (msg === undefined) {
        this.resetPasswordModal.message = null
        this.resetPasswordModal.data.oldPassword = null
        this.resetPasswordModal.data.newPassword = null
        this.resetPasswordModal.data.newPasswordConform = null
        this.resetPasswordModal.show = false
      } else {
        this.resetPasswordModal.message = msg
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 46px;
  padding: 8px;
  background-color: black;

  .title {
    color: #fff;
    font-weight: bold;
    padding: 2px 8px 3px;
    font-size: 15px;
    float: left;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ivu-btn:focus {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .menu {
    padding-left: 10px;
    float: right;
  }

  .attention {
    float: right;
    padding: 3px 6px 3px;

    button {
      padding: 3px 20px;
      font-size: 12px;

      i {
        padding: 0 0 2px;
        vertical-align: middle;
      }
    }

    .content {
      width: 430px;
      padding: 15px;
    }
  }

  .marquee {
     margin-left: 240px;
     margin-right: 240px;
     padding: 4px 0;
  }
}
</style>
